<template>
    <div class="col-11 col-sm-9 col-md-7 col-xl-4 mx-auto">
        <div class="card p-2 pl-5 pr-5">     
            <div class="card-body">
                <img alt="Vue logo" class="login-logo" src="../assets/logo.png" style="height: 100px">
                <form class="pt-3">
                    <div class="form-group">
                        <label for="email" class="font-weight-bold">Correo electrónico</label>
                        <input v-model="loginData.user" type="email" class="form-control" id="email" aria-describedby="emailHelp" placeholder="Correo de ingreso">
                    </div>
                    <div class="form-group">
                        <label for="password" class="font-weight-bold">Contraseña</label>
                        <input v-model="loginData.password" type="password" class="form-control" id="password" placeholder="Contraseña">
                    </div>
                    <button v-on:click.prevent="login" type="submit" class="btn btn-primary btn-block mt-4 mb-4">Iniciar sesión</button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    beforeMount: function(){
        let token = localStorage.getItem("session_id");
        let user = JSON.parse(localStorage.getItem("user"));

        if(token != null && user != null){
            if(user.type == "admin"){
                this.$router.push("admin/cities");
            } else if(user.type == "entity"){
                this.$router.push("cases");
            }
        } else {
            localStorage.clear();
        }
    },
    name: 'loginform',
    data() {
        return {
            loginData: {
                user: "",
                password: "",
            }
        }
    },
    methods: {
        login: function(){
            if(this.loginData.user != "" && this.loginData.password != ""){
                //Show the loader when the request is sent
                let loader = this.$loading.show();
                this.$http.post(`${process.env.VUE_APP_API}/auth/login`, this.loginData)
                .then(function(data){
                    loader.hide();
                    var token = data.body.token;
                    var user = data.body.user;
                    localStorage.setItem('session_id', token);
                    localStorage.setItem('user', JSON.stringify(user));
                    if(user.type == "admin"){
                        this.$router.push('admin/entities');
                    } else if(user.type == "entity"){
                        this.$router.push('cases');
                    }
                })
                .catch(function(error){
                    this.$dialogs.alert("Usuario o contraseña incorrectos", {title: 'Error', size: 'sm'});
                    loader.hide();
                    this.loginData = {};
                });
            } else {
                this.$dialogs.alert("Se requiere el email y la contraseña para iniciar sesión", {title: 'Error', size: 'sm'});
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .card {
        box-shadow: 0px 0px 5px rgba(180, 180, 180, 0.5);
    }

    .login-logo {
        overflow: hidden;
        border-radius: 50%;
    }
</style>


